import { render, staticRenderFns } from "./BreadDataRecordList.vue?vue&type=template&id=436289c1&scoped=true&"
import script from "./BreadDataRecordList.vue?vue&type=script&lang=js&"
export * from "./BreadDataRecordList.vue?vue&type=script&lang=js&"
import style0 from "./BreadDataRecordList.vue?vue&type=style&index=0&id=436289c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436289c1",
  null
  
)

export default component.exports